module.exports = __webpack_public_path__ + "img/honor.296d8981.png";